import React, { useState } from 'react'
import {
  Button,
  Modal,
  Spin,
  Checkbox,
  message,
  Form,
  Select,
  Table,
  InputNumber,
  Row,
  Col,
  List,
  Divider
} from 'antd'
import IntlMessages from '../../util/IntlMessages'
import ds from '../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getDecryptID } from '../../appRedux/actions/GlobalMethods'
import { ArrowRightOutlined, MinusOutlined } from '@ant-design/icons'

const { Option } = Select
const InventoryAdjustments = props => {
  const { show, onClose, data, prodInfo, prodType, prodName } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()
  const FormItem = Form.Item
  const [getLoading, setLoading] = React.useState(false)
  // const [prodSelectedOutlet, setProdSelectedOutlet] = React.useState('')
  const [outletChoosed, setOutletChoosed] = React.useState(false)
  const [outletName, setOutletName] = React.useState('')
  // const [number, setNumber] = React.useState(0)
  const [disable, setDisable] = React.useState(false)
  const [loader, setLoader] = React.useState(false)
  const [prodSelected, setProdSelected] = React.useState(false)
  const [selectedProducts, setSelectedProducts] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const [prodData, setProdData] = useState([])

  const invAdjMovement = useSelector(({ Setup }) => Setup.invAdjMovement)

  React.useEffect(() => {
    let mounted = true
    if (prodInfo && prodInfo.length > 0) {
    }
    if (mounted) {
      if (
        data &&
        data.length > 0 &&
        data[0].outletInventoriesandTax &&
        data[0].outletInventoriesandTax.length == 1
      ) {
        setOutletName(data[0].outletInventoriesandTax[0].outletName)
        setOutletChoosed(true)
      }
    }
    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted && outletName) {
      const prod = []
      if (prodType && prodType == '0') {
        data &&
          data.length > 0 &&
          data[0].outletInventoriesandTax &&
          data[0].outletInventoriesandTax.length > 0 &&
          data[0].outletInventoriesandTax.map(d => {
            if (d.outletName && d.outletName == outletName) {
              const body = {
                productName:
                  prodInfo && prodInfo.length > 0 && prodInfo[0].productName
                    ? prodInfo[0].productName
                    : '',
                totalInventoryCount: d.currentInventory,
                prodID:
                  prodInfo && prodInfo.length > 0 && prodInfo[0].key
                    ? getDecryptID(prodInfo[0].key)
                    : 0,
                resultInventoryCount: 0,
                outletID: d.outletID,
                outletName: d.outletName
              }
              prod.push(body)
            }
          })
        if (prod && prod.length > 0) setProdData(prod)
        else setProdData([])
      } else if (prodType && prodType == '1') {
        if (selectedProducts && selectedProducts.length > 0 && prodSelected) {
          selectedProducts.map(q => {
            const findProd = data.filter(
              tt => getDecryptID(tt.productID) == getDecryptID(q)
            )
            if (findProd && findProd.length > 0) {
              const d = findProd[0]
              let prodName =
                prodInfo && prodInfo.length > 0 && prodInfo[0].productName
                  ? prodInfo[0].productName
                  : ''
              prodName += `/${d.variantName}`
              let inventoryCount = ''
              let outID = ''
              let outName = ''
              d.outletInventoriesandTax &&
                d.outletInventoriesandTax.length > 0 &&
                d.outletInventoriesandTax.map(gg => {
                  if (gg.outletName && gg.outletName == outletName) {
                    inventoryCount = gg.currentInventory
                    outID = gg.outletID
                    outName = gg.outletName
                  }
                })

              const body = {
                productName: prodName,
                totalInventoryCount: inventoryCount,
                prodID: d && d.productID ? getDecryptID(d.productID) : 0,
                resultInventoryCount: 0,
                outletID: outID,
                outletName: outName
              }
              prod.push(body)
            }
          })
          if (prod && prod.length > 0) setProdData(prod)
          else setProdData([])
        }
      }
    }
    return () => (mounted = false)
  }, [outletName, prodSelected])

  // React.useEffect(() => {
  //   let mounted = true
  //   if (mounted) {
  //     if (
  //       invAdjMovement &&
  //       invAdjMovement.length > 0 &&
  //       invAdjMovement[0].totalInventoryCount
  //     ) {
  //       const val = parseInt(invAdjMovement[0].totalInventoryCount)
  //       if (number < val) {
  //         setDisable(true)
  //       } else setDisable(false)
  //     }
  //   }
  //   return () => (mounted = false)
  // }, [number])

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo)
  }

  const onFinish = values => {
    if (outletChoosed && prodType == '1' && !prodSelected) {
      if (selectedProducts.length > 0) {
        setProdSelected(true)
      }
    } else {
      if (outletChoosed && prodData && prodData.length > 0) {
        const body = { InvData: [] }
        prodData.map(info => {
          if (info) {
            const msgTo = form.getFieldValue(
              `reasonSelection_${info.prodID ? info.prodID : 0}`
            )
              ? form.getFieldValue(
                  `reasonSelection_${info.prodID ? info.prodID : 0}`
                )
              : ''
            let quantity = form.getFieldValue(
              `quantity_${info.prodID ? info.prodID : 0}`
            )
            if (quantity) quantity = -Math.abs(quantity)
            else quantity = 0
            body.InvData.push({
              OutletID: info.outletID ? info.outletID : '',
              ProductID: info.prodID
                ? `${info.prodID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
                : '',
              MsgFrom: 'On Hand',
              MsgTo: msgTo,
              ProductCount: [
                {
                  ProductID: info.prodID ? info.prodID : 0,
                  ProductCount: quantity,
                  IsAdd: true,
                  IsReplace: false,
                  IsStockGain: false,
                  FromMessage: 'On Hand',
                  ToMessage: msgTo,
                  MovementName: 'Inventory Adjustment',
                  IsTrackInventory: true,
                  LastCount: info.totalInventoryCount
                    ? parseInt(info.totalInventoryCount)
                    : 0
                }
              ]
            })
          }
        })
        if (body && body.InvData && body.InvData.length > 0)
          postInvAdjService(body)
      } else {
        if (values.outlet) {
          setOutletChoosed(true)
          // setProdSelectedOutlet(values.outlet)
          const outlet = data[0].outletInventoriesandTax.filter(
            a => a.outletID == values.outlet
          )
          if (outlet && outlet.length > 0) setOutletName(outlet[0].outletName)
        }
      }
    }
  }

  async function postInvAdjService (body) {
    setLoader(true)
    await ds
      .postInvAdjustmentService(body)
      .then(res => {
        setLoader(false)
        if (res) message.success('Updated Successfully')
        else message.error('Failed to update')
        onClosePopUp()
      })
      .catch(e => {
        setLoader(false)
      })
  }

  function onClosePopUp () {
    setProdSelected(false)
    setProdData([])
    setSelectedProducts([])
    setSelectAll(false)
    form.resetFields()
    // setProdSelectedOutlet('')
    setOutletName('')
    setOutletChoosed(false)
    onClose()
  }

  const handleKeyPress = (event) => {
    if (event.key === '.' || event.key === ',') {
      event.preventDefault(); // Prevent entering the dot or comma
    }
  };

  const columns = [
    {
      title: 'Product',
      dataIndex: 'productName',
      key: 'productName',
      render: text => {
        return (
          <span style={{ fontWeight: '500' }}>
            <strong>{text}</strong>
          </span>
        )
      }
    },
    {
      title: 'Adjustment Reason',
      dataIndex: 'reason',
      key: 'reason',
      render: (text, record) => {
        return (
          <Form
            // {...formItemLayout}
            form={form}
            name='outletInv'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment form-inner-pad-0'
              name={`reasonSelection_${record.prodID ? record.prodID : 0}`}
              // label={'Day'}
              rules={[
                {
                  required: true,
                  message: 'Kindly choose a reason'
                }
              ]}
            >
              <Select
                placeholder='Choose a reason'
                // onChange={handleDayChange}
                // value={selectedDay}
                style={{ width: '100%' }}
              >
                {invAdjMovement && invAdjMovement.length > 0 ? (
                  invAdjMovement.map((e, key) => {
                    return (
                      <Option key={key} value={e.displayName}>
                        {e.displayName}
                      </Option>
                    )
                  })
                ) : (
                  <Option>Choose a reason</Option>
                )}
              </Select>
            </Form.Item>
          </Form>
        )
      }
    },
    {
      title: 'Adjustment Quantity',
      dataIndex: 'numofproducts',
      key: 'numofproducts',
      render: (text, record) => {
        return (
          <Form
            // {...formItemLayout}
            form={form}
            name='outletInv'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment form-inner-pad-0'
              name={`quantity_${record.prodID ? record.prodID : 0}`}
              // // label={'Day'}
              // rules={[
              //   {
              //     required: true,
              //     message: 'Kindly choose a reason'
              //   }
              // ]}
            >
              <MinusOutlined style={{ marginRight: 8 }} />
              <InputNumber
                type='number'
                min={0}
                onKeyPress={handleKeyPress}
                onChange={e => {
                  form.setFieldsValue({
                    [`quantity_${record.prodID ? record.prodID : 0}`]: e
                  })
                  let data = [...prodData]
                  const value = parseInt(
                    record.totalInventoryCount ? record.totalInventoryCount : 0
                  )
                  const number = e
                  let resValue = number ? -Math.abs(number) : 0
                  if (resValue) resValue += value

                  // update result count in array table data
                  data
                    .filter(a => a.prodID == record.prodID)
                    .map(w => (w.resultInventoryCount = resValue))
                  setProdData(data)
                }}
              />
            </Form.Item>
          </Form>
        )
      }
    },
    {
      title: `Inventory ${outletName}`,
      key: 'resultInventoryCount',
      render: (text, record) => {
        // const value = parseInt(
        //   record.totalInventoryCount ? record.totalInventoryCount : 0
        // )
        // const number = form.getFieldValue(
        //   `quantity_${record.prodID ? record.prodID : 0}`
        // )
        //   ? form.getFieldValue(`quantity_${record.prodID ? record.prodID : 0}`)
        //   : 0
        // let resValue = number ? -Math.abs(number) : 0
        // if (resValue) resValue -= value

        return (
          <Row
            justify='space-around'
            style={{ marginBottom: 10, fontSize: 20 }}
          >
            <Col>{record.totalInventoryCount}</Col>
            <Col>
              <ArrowRightOutlined
                style={{
                  color: 'green', // value == resValue ? 'green' : 'red',
                  marginRight: 4
                }}
              />
            </Col>
            <Col>
              {record.resultInventoryCount ? record.resultInventoryCount : 0}
            </Col>
          </Row>
        )
      }
    }
  ]

  const handleSelectAll = e => {
    const checked = e.target.checked
    setSelectAll(checked)
    setSelectedProducts(checked ? data.map(p => p.productID) : [])
  }

  const handleProductSelect = (productId, checked) => {
    setSelectedProducts(prev =>
      checked ? [...prev, productId] : prev.filter(id => id !== productId)
    )
  }

  return (
    <Modal
      title={
        <span>
          {data &&
          data.length > 0 &&
          data[0].outletInventoriesandTax &&
          data[0].outletInventoriesandTax.length > 0
            ? 'Choose an Outlet to adjust Inventory'
            : 'Choose a reason and quantity to adjust'}
        </span>
      }
      className='adjustInventory-Modal'
      visible={show}
      centered={true}
      footer={
        <>
        <Form
        // initialValues={{ remember: true }}
        form={form}
        name='outletInv'
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <FormItem className='gx-text-right'>
          <Button size='large' className='dk-btn-cancel' onClick={onClosePopUp}>
            <IntlMessages id='common.resource.cancel' />
          </Button>

          <Button
            size='large'
            className='dk-btn-add'
            type='primary'
            htmlType='submit'
            disabled={
              // // // NOTE: Disabled button for variant products product listing not choosing
              outletChoosed &&
              prodType == '1' &&
              !prodSelected &&
              selectedProducts.length == 0
            }
          >
            {outletChoosed && prodType == '1' && !prodSelected ? (
              'Next'
            ) : (
              <IntlMessages id='switchbar.submit' />
            )}
          </Button>
          
        </FormItem>
      </Form>
        </>
      }
      width={outletChoosed ? 800 : ''}
    >
      {!outletChoosed &&
      data &&
      data.length > 0 &&
      data[0].outletInventoriesandTax &&
      data[0].outletInventoriesandTax.length > 0 ? (
        <Spin
          tip={<IntlMessages id='sell.cashlisting.cashloading' />}
          spinning={getLoading}
          size='large'
        >
          <div>
            <h3 className='custom-gray-text'>Outlet</h3>
          </div>
          <Form
            // initialValues={{ remember: true }}
            form={form}
            name='outletInv'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            className='gx-signin-form gx-form-row0'
          >
            <FormItem
              rules={[{ required: true, message: 'Please select Outlet' }]}
              name='outlet'
            >
              <Select
                size='large'
                placeholder={'Choose an outlet'}
                // disabled={getIsDisable}
              >
                {data &&
                  data.length > 0 &&
                  data[0].outletInventoriesandTax &&
                  data[0].outletInventoriesandTax.length > 0 &&
                  data[0].outletInventoriesandTax.map((e, key) => {
                    return (
                      <option key={key} value={e.outletID}>
                        {e.outletName}
                      </option>
                    )
                  })}
              </Select>
            </FormItem>
          </Form>
        </Spin>
      ) : (
        <Spin
          tip={<IntlMessages id='sell.cashlisting.cashloading' />}
          spinning={loader}
          size='large'
        >
          {prodType == '1' && !prodSelected ? (
            <div className='adjustInventory-content theme-scroll scroll-height-3'>
           
                <h4 className='mb-3'>
                  {prodInfo &&
                    prodInfo.length > 0 &&
                    prodInfo[0].productName &&
                    `Choose variants of "${prodInfo[0].productName}" to adjust`}
                </h4>
              
              <div className='mt-2'>
                <Checkbox onChange={handleSelectAll} checked={selectAll}>
                  <p className='mb-0'>Select All</p>
                </Checkbox>
                <Divider className='mt-2 mb-2' />
                <List
                  dataSource={data}
                  renderItem={product => (
                    <List.Item>
                      <Checkbox
                        onChange={e =>
                          handleProductSelect(
                            product.productID ? product.productID : 0,
                            e.target.checked
                          )
                        }
                        checked={selectedProducts.includes(
                          product.productID ? product.productID : 0
                        )}
                      >
                        <p className='mb-0'>
                          {`${prodName ? prodName + '/' : ''}` +
                            product.variantName}
                        </p>
                      </Checkbox>
                    </List.Item>
                  )}
                />
              </div>

            </div>
          ) : (
            <>
              <div className='adjustInventory-content theme-scroll scroll-height-3'>

                <p>
                  Inventory will be adjusted at the chosen outlet and the
                  adjustment quantity and reason will be recorded.
                </p>

              
              <Table
                className='gx-table-responsive'
                // loading={isLoadingTable}
                columns={columns}
                dataSource={prodData}
                pagination={false}
                // onChange={handleTableChange}
              />

</div>
            </>
          )}
        </Spin>
      )}
      
    </Modal>
  )
}

export default InventoryAdjustments
